import { Variants } from 'framer-motion';

export const subFilterVariants = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.25 } },
    exit: { opacity: 0, transition: { duration: 0.2 } },
  } as Variants,
  slideUp: {
    initial: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30, transition: { duration: 0.25 } },
  } as Variants,
};
